import { withNamespaces } from "react-i18next";
import { AvFeedback, AvField, AvGroup, AvInput } from "availity-reactstrap-validation";
import { useMutation } from "@tanstack/react-query";
import UserValidationService from "src/apis/UserValidationService";
import { useState } from "react";
import { connect } from "react-redux";
import { Spinner } from "reactstrap";

const ValidatableEmail = ({
    t,
    index,
    modules,
    name,
    value,
    onChange
}) => {
    const [validationStatus, setValidationStatus] = useState(null);
    const checkUserExistenceMutation = useMutation({
        mutationFn: async (payload) => {
            const service = UserValidationService.getInstance();

            return await service.checkEmailExistence(payload, modules.active);
        }
    });

    const onBlur = (e) => {
        if(validationStatus) return;
        if(!e.target.value) return setValidationStatus(null);
        
        setValidationStatus('in_process');
        checkUserExistenceMutation.mutate({
            email : e.target.value
        }, {
            onSuccess: () => {
                setValidationStatus('valid');
            },
            onError: () => {
                setValidationStatus('invalid');
            }
        })
    }

    const error = checkUserExistenceMutation?.error?.response?.data;

    return  (
        <div className="validatable-email">
            <AvGroup>
                <AvField
                    name={name}
                    type="email"
                    errorMessage={t("This field cannot be blank")}
                    className="form-control"
                    validate={{
                        required: { 
                            value: true 
                        },
                        email: true
                    }}
                    value={value}
                    id={name}
                    onChange={(e) => {
                        validationStatus && setValidationStatus(null);
                        onChange && onChange(e);
                    }}
                    onBlur={onBlur}
                    disabled={validationStatus === 'in_process'}
                />

                <AvInput 
                    name={`hidden_in_process_{${index}}`}
                    type='hidden'
                    errorMessage={''}
                    validate={{
                        required: { 
                            value: validationStatus === 'in_process'
                        }
                    }}
                />

                {validationStatus === 'in_process' && (
                    <AvFeedback
                        className="d-block text-info"
                    >
                        <Spinner 
                            size='sm'
                            color="primary"
                            className="me-1"
                        />
                        {t('Validating email address.please wait...')}
                    </AvFeedback>
                )}

                {validationStatus === 'invalid' && (
                    <>
                        {modules.active === 'tp' && error?.error?.isAd ? (
                            <AvFeedback 
                                className="d-block text-warning"
                            >
                                <i className="ri-error-warning-line font-size-18 me-1 align-middle" />
                                {t('This user already exists in the system with the role of Employee. By submitting the form, their role will be updated to the new role you have selected (Analyst or Analyst Admin).')}
                            </AvFeedback>
                        ) : (
                            <>
                                <AvFeedback valid={false} className='d-block'>
                                    {t('Email already exists')}
                                </AvFeedback>
                                <AvInput 
                                    name={`hidden_{${index}}`}
                                    type='hidden'
                                    errorMessage={''}
                                    validate={{
                                        required: { 
                                            value: true
                                        }
                                    }}
                                />
                            </>
                        )}
                    </>
                )}
            </AvGroup>
        </div>
    )
}   

export default withNamespaces()(
    connect((state) => {
        const { Modules } = state;
        return {
            modules: Modules
        };
    })(
        ValidatableEmail
    )
);